/** Generate by swagger-axios-codegen */
// @ts-ignore
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-ignore
import axiosStatic, { AxiosInstance, AxiosRequestConfig } from "axios";

import { Expose, Transform, Type, plainToClass } from "class-transformer";

export interface IRequestOptions extends AxiosRequestConfig {}

export interface IRequestConfig {
    method?: any;
    headers?: any;
    url?: any;
    data?: any;
    params?: any;
}

// Add options interface
export interface ServiceOptions {
    axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(
    configs: IRequestConfig,
    resolve: (p: any) => void,
    reject: (p: any) => void
): Promise<any> {
    if (serviceOptions.axios) {
        return serviceOptions.axios
            .request(configs)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    } else {
        throw new Error("please inject yourself instance like axios  ");
    }
}

export function getConfigs(
    method: string,
    contentType: string,
    url: string,
    options: any
): IRequestConfig {
    const configs: IRequestConfig = { ...options, method, url };
    configs.headers = {
        ...options.headers,
        "Content-Type": contentType,
    };
    return configs;
}

export const basePath = "";

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
    [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
    items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
    items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
    totalCount?: number;
    items?: T[];
}

export class PagedResultDto<T> implements IPagedResult<T> {
    totalCount?: number;
    items?: T[];
}

// customer definition
// empty

export class CaseExportService {
    /**
     *
     */
    static caseExport(
        params: {
            /**  */
            attorneyId: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GuidDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CaseExport/{attorneyID}";
            url = url.replace("{attorneyID}", params["attorneyId"] + "");

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(GuidDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static caseExport1(
        params: {
            /**  */
            id: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CaseSearchStatusDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/CaseExport/{id}";
            url = url.replace("{id}", params["id"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(CaseSearchStatusDetailedResponse, response)
                    ),
                reject
            );
        });
    }
}

export class CasesService {
    /**
     *
     */
    static poll(
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Cases/Poll";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static cases(
        params: {
            /** requestBody */
            body?: CourtCase;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CourtCaseDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Cases";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(CourtCaseDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static search(
        params: {
            /** requestBody */
            body?: CaseSearch;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CourtCaseListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Cases/Search";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(CourtCaseListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static serviceList(
        params: {
            /**  */
            countyId?: string;
            /**  */
            ucn?: string;
            /**  */
            attorneyId?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<ServiceContactListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Cases/ServiceList";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                countyId: params["countyId"],
                ucn: params["ucn"],
                attorneyId: params["attorneyId"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            ServiceContactListDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static byReferenceNumber(
        params: {
            /**  */
            attorneyId?: string;
            /**  */
            portalIdentifier?: string;
            /**  */
            referenceNumber?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CourtCaseDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Cases/ByReferenceNumber";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                attorneyId: params["attorneyId"],
                portalIdentifier: params["portalIdentifier"],
                referenceNumber: params["referenceNumber"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(CourtCaseDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static bySequenceNumber(
        params: {
            /**  */
            attorneyId: string;
            /**  */
            sequenceNumber: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CourtCaseListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/Cases/BySequenceNumber/{attorneyId}/{sequenceNumber}";
            url = url.replace("{attorneyId}", params["attorneyId"] + "");
            url = url.replace(
                "{sequenceNumber}",
                params["sequenceNumber"] + ""
            );

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(CourtCaseListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static searchByUcn(
        params: {
            /**  */
            ucn: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<NewCaseDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Cases/SearchByUCN/{ucn}";
            url = url.replace("{ucn}", params["ucn"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(NewCaseDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static status(
        params: {
            /**  */
            state: string;
            /**  */
            ucn: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<SimpleCaseInformationDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Cases/Status/{state}/{ucn}";
            url = url.replace("{state}", params["state"] + "");
            url = url.replace("{ucn}", params["ucn"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(
                            SimpleCaseInformationDetailedResponse,
                            response
                        )
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static myCases(
        params: {
            /**  */
            attorneyId?: string;
            /**  */
            countyId?: string;
            /**  */
            caseStyle?: string;
            /**  */
            caseNumber?: string;
            /**  */
            itemsPerSearch?: number;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CourtCaseListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Cases/MyCases";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                attorneyId: params["attorneyId"],
                countyId: params["countyId"],
                caseStyle: params["caseStyle"],
                caseNumber: params["caseNumber"],
                itemsPerSearch: params["itemsPerSearch"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(CourtCaseListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static caseByUcn(
        params: {
            /**  */
            attorneyId?: string;
            /**  */
            countyId?: string;
            /**  */
            divsionId?: string;
            /**  */
            ucn?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CourtCaseDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Cases/CaseByUCN";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = {
                attorneyId: params["attorneyId"],
                countyId: params["countyId"],
                divsionId: params["divsionId"],
                ucn: params["ucn"],
            };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(CourtCaseDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static longcasesearch(
        params: {
            /** requestBody */
            body?: CaseSearch;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GuidDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Cases/longcasesearch";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(GuidDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static caseSearchpoll(
        params: {
            /**  */
            id?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CourtCaseListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/Cases/CaseSearchpoll";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { id: params["id"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(CourtCaseListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static longcasesearch1(
        params: {
            /** requestBody */
            body?: CaseSearch;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<GuidDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/Cases/longcasesearch";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(GuidDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static search1(
        params: {
            /** requestBody */
            body?: CaseSearch;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CourtCaseListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/Cases/search";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(CourtCaseListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
    /**
     *
     */
    static getcasebyucn(
        params: {
            /**  */
            countyId: string;
            /**  */
            divsionId: string;
            /**  */
            ucn: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CourtCaseDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url =
                basePath +
                "/api/tyler/Cases/getcasebyucn/{countyId}/{divsionId}/{ucn}";
            url = url.replace("{countyId}", params["countyId"] + "");
            url = url.replace("{divsionId}", params["divsionId"] + "");
            url = url.replace("{ucn}", params["ucn"] + "");

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );

            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(CourtCaseDetailedResponse, response)),
                reject
            );
        });
    }
    /**
     *
     */
    static poll1(
        params: {
            /**  */
            id?: string;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<CourtCaseListDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/tyler/Cases/poll";

            const configs: IRequestConfig = getConfigs(
                "get",
                "application/json",
                url,
                options
            );
            configs.params = { id: params["id"] };
            let data = null;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(
                        plainToClass(CourtCaseListDetailedResponse, response)
                    ),
                reject
            );
        });
    }
}

export class ServiceContactsService {
    /**
     *
     */
    static serviceContacts(
        params: {
            /** requestBody */
            body?: ServiceContact[];
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<BooleanDetailedResponse> {
        return new Promise((resolve, reject) => {
            let url = basePath + "/api/ServiceContacts";

            const configs: IRequestConfig = getConfigs(
                "post",
                "application/json",
                url,
                options
            );

            let data = params.body;

            configs.data = data;
            axios(
                configs,
                (response: any) =>
                    resolve(plainToClass(BooleanDetailedResponse, response)),
                reject
            );
        });
    }
}

export class Address {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "fullAddress"?: string;

    /**  */
    "streetAddress"?: string;

    /**  */
    "unit"?: string;

    /**  */
    "city"?: string;

    /**  */
    "state"?: string;

    /**  */
    "zip"?: string;

    /**  */
    "active"?: boolean;

    /**  */
    @Expose()
    "latitude"?: number;

    /**  */
    @Expose()
    "longitude"?: number;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["fullAddress"] = data["fullAddress"];
        this["streetAddress"] = data["streetAddress"];
        this["unit"] = data["unit"];
        this["city"] = data["city"];
        this["state"] = data["state"];
        this["zip"] = data["zip"];
        this["active"] = data["active"];
        this["latitude"] = data["latitude"];
        this["longitude"] = data["longitude"];
    }

    public static validationModel = {};
}

export class BooleanDetailedResponse {
    /**  */
    "data"?: boolean;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class CaseSearch {
    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "state"?: string;

    /**  */
    @Expose()
    "countyID"?: string;

    /**  */
    @Expose()
    "divisionID"?: string;

    /**  */
    "courtIdentifier"?: string;

    /**  */
    "sequenceNumber"?: string;

    /**  */
    @Expose()
    "year"?: number;

    /**  */
    "partyIdentifier"?: string;

    /**  */
    "locationIdentifier"?: string;

    /**  */
    "caseNumber"?: string;

    /**  */
    "firstName"?: string;

    /**  */
    "lastName"?: string;

    /**  */
    "organization"?: string;

    /**  */
    "trackingNumber"?: string;

    /**  */
    "ucn"?: string;

    /**  */
    "username"?: string;

    /**  */
    "passwordHash"?: string;

    constructor(data: undefined | any = {}) {
        this["attorneyID"] = data["attorneyID"];
        this["state"] = data["state"];
        this["countyID"] = data["countyID"];
        this["divisionID"] = data["divisionID"];
        this["courtIdentifier"] = data["courtIdentifier"];
        this["sequenceNumber"] = data["sequenceNumber"];
        this["year"] = data["year"];
        this["partyIdentifier"] = data["partyIdentifier"];
        this["locationIdentifier"] = data["locationIdentifier"];
        this["caseNumber"] = data["caseNumber"];
        this["firstName"] = data["firstName"];
        this["lastName"] = data["lastName"];
        this["organization"] = data["organization"];
        this["trackingNumber"] = data["trackingNumber"];
        this["ucn"] = data["ucn"];
        this["username"] = data["username"];
        this["passwordHash"] = data["passwordHash"];
    }

    public static validationModel = {};
}

export class CaseSearchStatus {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    "running"?: boolean;

    /**  */
    "status"?: string;

    /**  */
    "error"?: boolean;

    /**  */
    "response"?: string;

    /**  */
    "params"?: string;

    /**  */
    @Expose()
    @Type(() => Date)
    "startTime"?: Date;

    /**  */
    @Expose()
    @Type(() => Date)
    "endTime"?: Date;

    /**  */
    "executeKey"?: JobExecuteKeys;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["running"] = data["running"];
        this["status"] = data["status"];
        this["error"] = data["error"];
        this["response"] = data["response"];
        this["params"] = data["params"];
        this["startTime"] = data["startTime"];
        this["endTime"] = data["endTime"];
        this["executeKey"] = data["executeKey"];
    }

    public static validationModel = {};
}

export class CaseSearchStatusDetailedResponse {
    /**  */
    "data"?: CaseSearchStatus;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class ContactInformation {
    /**  */
    @Expose()
    "submissionAddressID"?: number;

    /**  */
    "fullAddress"?: string;

    /**  */
    "state"?: string;

    /**  */
    "streetAddress1"?: string;

    /**  */
    "streetAddress2"?: string;

    /**  */
    "zip"?: string;

    /**  */
    "city"?: string;

    /**  */
    "phoneNumber"?: string;

    /**  */
    "emailAddress"?: string;

    constructor(data: undefined | any = {}) {
        this["submissionAddressID"] = data["submissionAddressID"];
        this["fullAddress"] = data["fullAddress"];
        this["state"] = data["state"];
        this["streetAddress1"] = data["streetAddress1"];
        this["streetAddress2"] = data["streetAddress2"];
        this["zip"] = data["zip"];
        this["city"] = data["city"];
        this["phoneNumber"] = data["phoneNumber"];
        this["emailAddress"] = data["emailAddress"];
    }

    public static validationModel = {};
}

export class CourtCase {
    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "trackingNumber"?: string;

    /**  */
    "ucn"?: string;

    /**  */
    @Expose()
    "caseID"?: number;

    /**  */
    "courtType"?: Court;

    /**  */
    "caseTitle"?: string;

    /**  */
    "caseNumber"?: string;

    /**  */
    @Expose()
    "countyID"?: string;

    /**  */
    "county"?: string;

    /**  */
    "circuit"?: string;

    /**  */
    "countyPortalID"?: string;

    /**  */
    "division"?: string;

    /**  */
    "divisionPortalID"?: string;

    /**  */
    "caseTypeCode"?: string;

    /**  */
    "caseSubTypeCode"?: string;

    /**  */
    "caseType"?: string;

    /**  */
    "caseSubType"?: string;

    /**  */
    "officer"?: string;

    /**  */
    "defendantName"?: string;

    /**  */
    "portalStatus"?: string;

    /**  */
    "notes"?: string;

    /**  */
    "caseClosed"?: boolean;

    /**  */
    "referenceNumber"?: string;

    /**  */
    "matterNumber"?: string;

    /**  */
    "state"?: string;

    /**  */
    "parties"?: Party[];

    /**  */
    "judicialOfficerName"?: string;

    /**  */
    "judicialOfficerID"?: string;

    /**  */
    "damagesCode"?: string;

    /**  */
    @Expose()
    "year"?: number;

    /**  */
    "sequenceNumber"?: string;

    /**  */
    @Expose()
    "caseTypeID"?: string;

    /**  */
    @Expose()
    "caseSubTypeID"?: string;

    /**  */
    @Expose()
    "divisionID"?: string;

    constructor(data: undefined | any = {}) {
        this["attorneyID"] = data["attorneyID"];
        this["trackingNumber"] = data["trackingNumber"];
        this["ucn"] = data["ucn"];
        this["caseID"] = data["caseID"];
        this["courtType"] = data["courtType"];
        this["caseTitle"] = data["caseTitle"];
        this["caseNumber"] = data["caseNumber"];
        this["countyID"] = data["countyID"];
        this["county"] = data["county"];
        this["circuit"] = data["circuit"];
        this["countyPortalID"] = data["countyPortalID"];
        this["division"] = data["division"];
        this["divisionPortalID"] = data["divisionPortalID"];
        this["caseTypeCode"] = data["caseTypeCode"];
        this["caseSubTypeCode"] = data["caseSubTypeCode"];
        this["caseType"] = data["caseType"];
        this["caseSubType"] = data["caseSubType"];
        this["officer"] = data["officer"];
        this["defendantName"] = data["defendantName"];
        this["portalStatus"] = data["portalStatus"];
        this["notes"] = data["notes"];
        this["caseClosed"] = data["caseClosed"];
        this["referenceNumber"] = data["referenceNumber"];
        this["matterNumber"] = data["matterNumber"];
        this["state"] = data["state"];
        this["parties"] = data["parties"];
        this["judicialOfficerName"] = data["judicialOfficerName"];
        this["judicialOfficerID"] = data["judicialOfficerID"];
        this["damagesCode"] = data["damagesCode"];
        this["year"] = data["year"];
        this["sequenceNumber"] = data["sequenceNumber"];
        this["caseTypeID"] = data["caseTypeID"];
        this["caseSubTypeID"] = data["caseSubTypeID"];
        this["divisionID"] = data["divisionID"];
    }

    public static validationModel = {};
}

export class CourtCaseDetailedResponse {
    /**  */
    "data"?: CourtCase;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class CourtCaseListDetailedResponse {
    /**  */
    "data"?: CourtCase[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class GuidDetailedResponse {
    /**  */
    @Expose()
    "data"?: string;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class NewCase {
    /**  */
    "uniformCaseNumber"?: string;

    /**  */
    "clerkCaseNumber"?: string;

    /**  */
    "portalReferenceNumber"?: string;

    /**  */
    "county"?: string;

    /**  */
    "division"?: string;

    constructor(data: undefined | any = {}) {
        this["uniformCaseNumber"] = data["uniformCaseNumber"];
        this["clerkCaseNumber"] = data["clerkCaseNumber"];
        this["portalReferenceNumber"] = data["portalReferenceNumber"];
        this["county"] = data["county"];
        this["division"] = data["division"];
    }

    public static validationModel = {};
}

export class NewCaseDetailedResponse {
    /**  */
    "data"?: NewCase;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class Party {
    /**  */
    @Expose()
    "id"?: string;

    /**  */
    @Expose()
    "submissionID"?: string;

    /**  */
    @Expose()
    "partyID"?: number;

    /**  */
    "barNumber"?: string;

    /**  */
    "firstName"?: string;

    /**  */
    "middleName"?: string;

    /**  */
    "lastName"?: string;

    /**  */
    "suffix"?: string;

    /**  */
    "organization"?: string;

    /**  */
    "guid"?: string;

    /**  */
    "paymentToken"?: string;

    /**  */
    "representedPartyGUID"?: string;

    /**  */
    "contactInfo"?: ContactInformation;

    /**  */
    "partyType"?: string;

    /**  */
    "partyTypeCode"?: string;

    /**  */
    "emailAddress"?: string;

    /**  */
    "interestedParty"?: Party;

    /**  */
    "routingNumber"?: string;

    /**  */
    "accountNumber"?: string;

    /**  */
    "accountName"?: string;

    /**  */
    @Expose()
    "efmeFilingFee"?: number;

    /**  */
    @Expose()
    "efmeFilingTaxAmount"?: number;

    /**  */
    "portalID"?: string;

    /**  */
    "attorneyID"?: string;

    /**  */
    "name"?: string;

    /**  */
    "fullName"?: string;

    /**  */
    "address"?: Address;

    /**  */
    "phoneNumber"?: string;

    /**  */
    "username"?: string;

    constructor(data: undefined | any = {}) {
        this["id"] = data["id"];
        this["submissionID"] = data["submissionID"];
        this["partyID"] = data["partyID"];
        this["barNumber"] = data["barNumber"];
        this["firstName"] = data["firstName"];
        this["middleName"] = data["middleName"];
        this["lastName"] = data["lastName"];
        this["suffix"] = data["suffix"];
        this["organization"] = data["organization"];
        this["guid"] = data["guid"];
        this["paymentToken"] = data["paymentToken"];
        this["representedPartyGUID"] = data["representedPartyGUID"];
        this["contactInfo"] = data["contactInfo"];
        this["partyType"] = data["partyType"];
        this["partyTypeCode"] = data["partyTypeCode"];
        this["emailAddress"] = data["emailAddress"];
        this["interestedParty"] = data["interestedParty"];
        this["routingNumber"] = data["routingNumber"];
        this["accountNumber"] = data["accountNumber"];
        this["accountName"] = data["accountName"];
        this["efmeFilingFee"] = data["efmeFilingFee"];
        this["efmeFilingTaxAmount"] = data["efmeFilingTaxAmount"];
        this["portalID"] = data["portalID"];
        this["attorneyID"] = data["attorneyID"];
        this["name"] = data["name"];
        this["fullName"] = data["fullName"];
        this["address"] = data["address"];
        this["phoneNumber"] = data["phoneNumber"];
        this["username"] = data["username"];
    }

    public static validationModel = {};
}

export class ServiceContact {
    /**  */
    @Expose()
    "attorneyID"?: string;

    /**  */
    "fullName"?: string;

    /**  */
    "name"?: string;

    /**  */
    "firstName"?: string;

    /**  */
    "middleName"?: string;

    /**  */
    "lastName"?: string;

    /**  */
    "email"?: string;

    /**  */
    "emailAddress"?: string;

    /**  */
    "userType"?: string;

    /**  */
    "caseNumber"?: string;

    /**  */
    "partyID"?: string;

    /**  */
    @Expose()
    "portalID"?: string;

    /**  */
    "caseGUID"?: string;

    /**  */
    "address"?: Address;

    /**  */
    "contactInfo"?: ContactInformation;

    constructor(data: undefined | any = {}) {
        this["attorneyID"] = data["attorneyID"];
        this["fullName"] = data["fullName"];
        this["name"] = data["name"];
        this["firstName"] = data["firstName"];
        this["middleName"] = data["middleName"];
        this["lastName"] = data["lastName"];
        this["email"] = data["email"];
        this["emailAddress"] = data["emailAddress"];
        this["userType"] = data["userType"];
        this["caseNumber"] = data["caseNumber"];
        this["partyID"] = data["partyID"];
        this["portalID"] = data["portalID"];
        this["caseGUID"] = data["caseGUID"];
        this["address"] = data["address"];
        this["contactInfo"] = data["contactInfo"];
    }

    public static validationModel = {};
}

export class ServiceContactListDetailedResponse {
    /**  */
    "data"?: ServiceContact[];

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export class SimpleCaseInformation {
    /**  */
    "ucn"?: string;

    /**  */
    "caseNumber"?: string;

    /**  */
    "title"?: string;

    /**  */
    "status"?: string;

    constructor(data: undefined | any = {}) {
        this["ucn"] = data["ucn"];
        this["caseNumber"] = data["caseNumber"];
        this["title"] = data["title"];
        this["status"] = data["status"];
    }

    public static validationModel = {};
}

export class SimpleCaseInformationDetailedResponse {
    /**  */
    "data"?: SimpleCaseInformation;

    /**  */
    "successful"?: boolean;

    /**  */
    "errorMessage"?: string;

    constructor(data: undefined | any = {}) {
        this["data"] = data["data"];
        this["successful"] = data["successful"];
        this["errorMessage"] = data["errorMessage"];
    }

    public static validationModel = {};
}

export type Court = 0 | 1 | 2 | 3 | 4 | 5;

export type JobExecuteKeys = 0 | 10 | 20;
